import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        debug: false,
        // Every namespace the app uses (public/locales/<lng>/<ns>.json), all preloaded.
        // A namespace that is not preloaded makes useTranslation suspend on first use. Because the
        // route tree sits inside <Suspense fallback={null}>, that suspension throws away the whole
        // in-progress render, so every render-phase useQuery in the subtree re-fires on each retry.
        // super-admin.json exists only in en_US; the other languages fall back to English.
        ns: [
            'common',
            'navigation',
            'super-admin',
            'users',
            'organization',
            'organization-numbers',
            'client-directory',
            'customer-settings',
            'app-settings',
            'release-notes',
            'transport',
            'orders',
            'country-names',
            'user-settings',
            'errors',
        ],
        // The ns to use for useTranslation() without any ns given
        defaultNS: 'common',
        // 'cimode' forces display of the labels without translation
        fallbackLng: 'en_US',
        lng: 'en_US',
        supportedLngs: ['en_US', 'sv_SE', 'no_NO', 'da_DK', 'fi_FI', 'debug'],
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
    });

export default i18n;
